// Strings for the admin pages: Doctors, Clinics, Catalogs.
const strings = {
  es: {
    // Doctors
    adm_doctors_desc: "Médicos con acceso a la plataforma. Desactivar conserva sus pacientes, notas y recetas.",
    adm_doctors_desc_sa: "Todos los médicos de la plataforma. Para crear uno con clínica asignada usa Usuarios.",
    adm_create_in_users: "Crear en Usuarios",
    adm_assistants_hint: "Los asistentes se gestionan en",
    adm_add_vs_invite_add: "Agregar: creas tú la cuenta y le compartes la contraseña.",
    adm_add_vs_invite_invite: "Invitar (recomendado): el médico recibe un enlace y define su propia contraseña.",
    adm_add_doctor_desc: "Crea la cuenta del médico en tu clínica. Tendrás que compartirle la contraseña por un medio seguro.",
    adm_invite_desc: "Recomendado: el médico recibe un enlace por correo y define su propia contraseña.",
    adm_invalid_email: "Correo no válido",
    adm_password_short: "Mínimo 8 caracteres",
    adm_deactivate_doctor_q: "¿Desactivar a {name}?",
    adm_deactivate_doctor_desc: "No podrá iniciar sesión; sus pacientes, notas y recetas se conservan. Puedes reactivarlo después.",
    adm_reactivate: "Reactivar",
    adm_reactivate_doctor_q: "¿Reactivar a {name}?",
    adm_reactivate_doctor_desc: "Podrá volver a iniciar sesión con su contraseña actual.",
    adm_doctor_deactivated: "Médico desactivado",
    adm_doctor_reactivated: "Médico reactivado",
    adm_edit_doctor: "Editar médico",
    adm_edit_doctor_desc: "Aquí puedes cambiar nombre y correo de acceso. La especialidad y la cédula las edita el médico en su perfil.",
    adm_revoke_q: "¿Revocar la invitación?",
    adm_revoke_desc: "El enlace enviado a {email} dejará de funcionar. Puedes invitarlo de nuevo después.",
    adm_invite_revoked: "Invitación revocada",
    adm_no_doctors: "Aún no hay médicos",
    adm_no_doctors_hint: "Invita a un médico para que se una a tu clínica.",
    adm_no_doctors_filtered: "No hay médicos con este filtro",
    adm_doctor_status: "Estado",
    adm_doctor_clinic_none: "Sin clínica",
    adm_link_copied_fail: "No se pudo copiar el enlace",
    // Clinics
    adm_clinics_desc: "Cada clínica tiene su propio acceso de administración, médicos y pacientes.",
    adm_add_clinic_desc: "Crea la clínica y su usuario administrador. Con este correo y contraseña la clínica inicia sesión.",
    adm_clinic_name: "Nombre de la clínica",
    adm_admin_email: "Correo del administrador",
    adm_doctor_count_one: "1 médico",
    adm_doctor_count_other: "{n} médicos",
    adm_delete_clinic: "Eliminar clínica",
    adm_delete_clinic_q: "¿Eliminar {name}?",
    adm_delete_clinic_desc: "Se eliminan la clínica y su acceso de administración. Solo es posible si no tiene médicos, pacientes, citas ni usuarios.",
    adm_clinic_deleted: "Clínica eliminada",
    adm_view_users: "Ver usuarios",
    adm_no_clinics: "Aún no hay clínicas",
    adm_no_clinics_hint: "Agrega la primera clínica para empezar.",
    // Catalogs
    adm_catalog_type: "Catálogo",
    adm_name_required: "El nombre es obligatorio",
    adm_edit_item: "Editar elemento",
    adm_item_desc: "Los elementos activos aparecen en los formularios de toda la plataforma.",
    adm_active_hint: "Desactivado: deja de ofrecerse en formularios pero se conserva en registros existentes.",
    adm_delete_item_q: "¿Eliminar «{name}»?",
    adm_delete_item_desc: "Si este elemento ya se usó en expedientes, es mejor desactivarlo: deja de ofrecerse en formularios y el historial queda intacto.",
    adm_item_deleted: "Elemento eliminado",
    adm_item_deactivated: "Elemento desactivado",
    adm_showing_of: "Mostrando {shown} de {total}. Usa la búsqueda para encontrar un elemento específico.",
    adm_showing_more: "Mostrando los primeros {shown}. Afina la búsqueda para ver otros resultados.",
    adm_load_more: "Cargar más",
    adm_no_items: "Este catálogo está vacío",
    adm_no_items_search: "Sin resultados para esta búsqueda",
  },
  en: {
    adm_doctors_desc: "Doctors with platform access. Deactivating keeps their patients, notes and prescriptions.",
    adm_doctors_desc_sa: "All doctors on the platform. To create one assigned to a clinic, use Users.",
    adm_create_in_users: "Create in Users",
    adm_assistants_hint: "Assistants are managed in",
    adm_add_vs_invite_add: "Add: you create the account and share the password.",
    adm_add_vs_invite_invite: "Invite (recommended): the doctor gets a link and sets their own password.",
    adm_add_doctor_desc: "Create the doctor's account in your clinic. You'll need to share the password securely.",
    adm_invite_desc: "Recommended: the doctor gets a link by email and sets their own password.",
    adm_invalid_email: "Invalid email",
    adm_password_short: "At least 8 characters",
    adm_deactivate_doctor_q: "Deactivate {name}?",
    adm_deactivate_doctor_desc: "They won't be able to sign in; their patients, notes and prescriptions are kept. You can reactivate them later.",
    adm_reactivate: "Reactivate",
    adm_reactivate_doctor_q: "Reactivate {name}?",
    adm_reactivate_doctor_desc: "They'll be able to sign in again with their current password.",
    adm_doctor_deactivated: "Doctor deactivated",
    adm_doctor_reactivated: "Doctor reactivated",
    adm_edit_doctor: "Edit doctor",
    adm_edit_doctor_desc: "Change the name and sign-in email here. Specialty and license are edited by the doctor in their profile.",
    adm_revoke_q: "Revoke the invitation?",
    adm_revoke_desc: "The link sent to {email} will stop working. You can invite them again later.",
    adm_invite_revoked: "Invitation revoked",
    adm_no_doctors: "No doctors yet",
    adm_no_doctors_hint: "Invite a doctor to join your clinic.",
    adm_no_doctors_filtered: "No doctors match this filter",
    adm_doctor_status: "Status",
    adm_doctor_clinic_none: "No clinic",
    adm_link_copied_fail: "Couldn't copy the link",
    adm_clinics_desc: "Each clinic has its own admin login, doctors and patients.",
    adm_add_clinic_desc: "Creates the clinic and its admin user. The clinic signs in with this email and password.",
    adm_clinic_name: "Clinic name",
    adm_admin_email: "Admin email",
    adm_doctor_count_one: "1 doctor",
    adm_doctor_count_other: "{n} doctors",
    adm_delete_clinic: "Delete clinic",
    adm_delete_clinic_q: "Delete {name}?",
    adm_delete_clinic_desc: "Deletes the clinic and its admin login. Only possible when it has no doctors, patients, appointments or users.",
    adm_clinic_deleted: "Clinic deleted",
    adm_view_users: "View users",
    adm_no_clinics: "No clinics yet",
    adm_no_clinics_hint: "Add the first clinic to get started.",
    adm_catalog_type: "Catalog",
    adm_name_required: "Name is required",
    adm_edit_item: "Edit item",
    adm_item_desc: "Active items are offered in forms across the platform.",
    adm_active_hint: "Inactive: no longer offered in forms but kept on existing records.",
    adm_delete_item_q: "Delete “{name}”?",
    adm_delete_item_desc: "If this item has been used in records, deactivating is better: it stops being offered in forms and history stays intact.",
    adm_item_deleted: "Item deleted",
    adm_item_deactivated: "Item deactivated",
    adm_showing_of: "Showing {shown} of {total}. Use search to find a specific item.",
    adm_showing_more: "Showing the first {shown}. Refine your search to see other results.",
    adm_load_more: "Load more",
    adm_no_items: "This catalog is empty",
    adm_no_items_search: "No results for this search",
  },
};

export default strings;
